import { Box, Grid, Tab, Tabs, styled } from "@mui/material";

import { PORTFOLIO_CHART_TYPES } from "../constants";
import PortfolioChartBox from "./Components/PortfolioChartBox";
import PortfolioChartDebit from "./Components/PortfolioChartDebit";
import SwipeableViews from "react-swipeable-views";
import { getPortfolioChart } from "store/slices/portfolio/portfolioSlice";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function PortfolioCard() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const chartType = +searchParams.get("chartType") || 0;

  const handleChangeChartType = (_, newValue) => {
    dispatch(getPortfolioChart({ walletTypeId: newValue }));
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      chartType: newValue,
    });
  };

  const handleChangeChartTypeIndex = (index) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      chartType: index,
    });
  };

  useEffect(() => {
    dispatch(getPortfolioChart({ walletTypeId: chartType }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TabsStyle value={chartType} onChange={handleChangeChartType}>
          {PORTFOLIO_CHART_TYPES?.map((type) => (
            <Tab label={type.name} value={type.key} />
          ))}
        </TabsStyle>
      </Grid>

      <Grid item xs={12}>
        <SwipeableViews
          disabled
          axis={"x-reverse"}
          index={chartType}
          onChangeIndex={handleChangeChartTypeIndex}
        >
          <Box value={0} index={0}>
            <PortfolioChartBox title="Spot & Margin" />
          </Box>

          <Box value={1} index={1}>
            <PortfolioChartBox title="Spot Wallet" />
          </Box>

          <Box value={2} index={2}>
            <PortfolioChartBox title="Margin Wallet" />
          </Box>
        </SwipeableViews>

        <PortfolioChartDebit />
      </Grid>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    maxWidth: "300px",
    margin: "auto",
    justifyContent: "space-between",
  },
}));

export default PortfolioCard;
